module.exports = __webpack_public_path__ + "img/Einheit_des_Zoll.56d781ef.svg";